import React, {Component} from 'react';
import { connect } from "react-redux";

class Greeting extends Component {
  render() {
    let greet = "Hi,";
    if(this.props.fn !== ""){
      greet = "Hi, "+this.props.fn;
    }
    return (
      <div style={{fontSize:'16px',display:'inline'}}>
        {greet}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    fn: state.FormReducer.fn
});

export default connect(mapStateToProps)(Greeting);



// WEBPACK FOOTER //
// ./src/components/partials/Greeting.js